module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-6.95f97eee.jpg";